const NAV = [
  { internal: true, href: "/vision", as: "/vision", text: "Vision" },
  { internal: true, href: "/impact", as: "/impact", text: "Impact" },
  // { internal: true, href: "/events", as: "/events", text: "Events" },
  {
    internal: true,
    href: "/initiatives",
    as: "/initiatives",
    text: "Initiatives"
  },
  { internal: true, href: "/news", as: "/news", text: "News" },
  {
    internal: true,
    href: "/timeline",
    as: "/timeline",
    text: "Timeline"
  },
  { internal: false, href: "https://shop.uclastore.com/c-988-centennial-collection.aspx", text: "Shop" }
];

export { NAV };
